import { Action } from '@ngrx/store';
import { ISco } from 'src/app/models/sco.interface';

export enum EScoActions {
  AddSco = '[Sco] Add Sco',
  PlaceSco = '[Sco] Place Sco',
  DelSco = '[Sco] Del Sco',
  InitSco = '[Sco] Init Sco',
}

export class AddSco implements Action {
  public readonly type = EScoActions.AddSco;
  constructor(public payload: ISco) {}
}

export class PlaceSco implements Action {
  public readonly type = EScoActions.PlaceSco;
  constructor(public payload: ISco) {}
}

export class DelSco implements Action {
  public readonly type = EScoActions.DelSco;
  constructor(public payload: ISco) {}
}

export class InitSco implements Action {
  public readonly type = EScoActions.InitSco;
}

export type ScoActions = AddSco | PlaceSco | DelSco | InitSco;
